// /***
//  * 询价管理-发起人搜索
//  */

// import React from 'react';
// import { getData } from '@util';
// import { Select, Spin } from 'antd';
// import { API_POST_BBC_SUPPLIER_ALL_LIST } from '@api';
// class PriceUser extends React.PureComponent {
//   state = {
//     users: [],
//     loading: false,
//   };

//   componentDidMount() {
//     this.getList();
//   }
//   // 获取用户
//   getList = () => {
//     this.setState({ loading: true, users: [] });
//     getData({
//       api: API_POST_BBC_SUPPLIER_ALL_LIST,
//       data: {},
//     })
//       .then(res => {
//         console.log('getList----', res);
//         const { data } = res;
//         this.setState({
//           users: data || [],
//           loading: false,
//         });
//       })
//       .finally(() => {
//         this.setState({
//           loading: false,
//         });
//       });
//   };

//   render() {
//     const { users, loading } = this.state;
//     const { isSingleSelect, renderValue } = this.props;
//     console.log('users----', users);

//     return (
//       <Select
//         mode={!isSingleSelect && 'tags'}
//         optionFilterProp="children"
//         allowClear
//         filterOption={false}
//         notFoundContent={loading ? <Spin size="small" /> : null}
//         showSearch
//         // onFocus={this.getList}
//         placeholder={'请选择'}
//         {...this.props}
//         onChange={x => {
//           if (!isSingleSelect) {
//             const y = Array.from(new Set(x));
//             this.props.onChange && this.props.onChange(y);
//           } else {
//             this.props.onChange && this.props.onChange(x);
//           }
//         }}>
//         {users.map(item => (
//           <Select.Option
//             title={item.id}
//             key={item.id}
//             value={renderValue ? renderValue(item) : item.id}>
//             {item.tempName}
//           </Select.Option>
//         ))}
//       </Select>
//     );
//   }
// }

// export default PriceUser;
/***
 * 询价管理-发起人搜索
 */

import React from 'react';
import { getData } from '@util';
import { Select, Spin } from 'antd';
import { API_POST_BBC_SUPPLIER_ALL_LIST } from '@api';
import { Debounce, Bind } from 'lodash-decorators';
class PriceUser extends React.PureComponent {
  state = {
    users: [],
    loading: false,
  };

  componentDidMount() {
    this.getList();
  }
  // 获取用户
  @Bind()
  @Debounce(1000)
  getList() {
    this.setState({ loading: true, users: [] });
    getData({
      api: API_POST_BBC_SUPPLIER_ALL_LIST,
      data: { pageNum: 1, pageSize: 1000 },
    })
      .then(res => {
        console.log('res?.data-22---', res?.data);

        this.setState({
          users: res?.data || [],
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    const { users, loading } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        optionFilterProp="children"
        allowClear
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        notFoundContent={loading ? <Spin size="small" /> : null}
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            this.props.onChange && this.props.onChange(x);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {users.map(item => (
          <Select.Option
            title={item.name}
            key={item.name}
            value={renderValue ? renderValue(item) : String(item?.id)}>
            {item?.tempName}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default PriceUser;
